// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IMccDto } from './IMccDto';
import {
    IMccDtoFromJSON,
    IMccDtoFromJSONTyped,
    IMccDtoToJSON,
    IMccDtoToJSONTyped,
} from './IMccDto';

/**
 * 
 * @export
 * @interface IServiceDto
 */
export interface IServiceDto {
    /**
     * 
     * @type {number}
     * @memberof IServiceDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IServiceDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IServiceDto
     */
    category_type?: IServiceDtoCategoryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IServiceDto
     */
    primary?: boolean;
    /**
     * 
     * @type {Array<IMccDto>}
     * @memberof IServiceDto
     */
    mcc_dto?: Array<IMccDto>;
    /**
     * 
     * @type {string}
     * @memberof IServiceDto
     */
    service_type?: IServiceDtoServiceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IServiceDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IServiceDtoServiceTypeEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}


/**
 * Check if a given object implements the IServiceDto interface.
 */
export function instanceOfIServiceDto(value: object): value is IServiceDto {
    return true;
}

export function IServiceDtoFromJSON(json: any): IServiceDto {
    return IServiceDtoFromJSONTyped(json, false);
}

export function IServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'primary': json['primary'] == null ? undefined : json['primary'],
        'mcc_dto': json['mcc_dto'] == null ? undefined : ((json['mcc_dto'] as Array<any>).map(IMccDtoFromJSON)),
        'service_type': json['service_type'] == null ? undefined : json['service_type'],
    };
}

export function IServiceDtoToJSON(json: any): IServiceDto {
    return IServiceDtoToJSONTyped(json, false);
}

export function IServiceDtoToJSONTyped(value?: IServiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'category_type': value['category_type'],
        'primary': value['primary'],
        'mcc_dto': value['mcc_dto'] == null ? undefined : ((value['mcc_dto'] as Array<any>).map(IMccDtoToJSON)),
        'service_type': value['service_type'],
    };
}

